export const types = {
    load: "[Load] Loading registers from table",
    setAnalityc: "[Load] Loading registers of one analityc",
    delete: "[Delete] Delete register",
    deleteRepair: "[Delete] Delete repair register",
    cleaningAll: "[Cleaning] Cleaning register from redux",
    change: "[Change] Changing value",
    changeRegister: "[Change] Changing value Regsiter",
    changeTab: "[Change] Changing tab",
    changeList: "[Change] Changing list options",
    setTotalSum: "[Load] Set total sum",
};
